import { render, staticRenderFns } from "./ExtraSearch.vue?vue&type=template&id=49ef4be5&scoped=true"
import script from "./ExtraSearch.vue?vue&type=script&lang=js"
export * from "./ExtraSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ef4be5",
  null
  
)

export default component.exports